const initRaffle = {
  raffles: [],
  winner: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  isRaffleCodeLoading: false,
  citiesFilter: [],
  isFilterLoading: false,
  filterCityPage: "",
};

export const raffleReducer = (state = initRaffle, action: any) => {
  if (action.type === "SET_RAFFLE") {
    return {
      ...state,
      raffles: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_RAFFLE_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_RAFFLE") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_WINNER") {
    return {
      ...state,
      winner: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_CODE_LOADING") {
    return {
      ...state,
      isRaffleCodeLoading: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_CITY_FILTER") {
    return {
      ...state,
      citiesFilter: [{ id: "", city: "All" }, ...action.value],
    };
  }
  if (action.type === "SET_FILTER_LOADING") {
    return {
      ...state,
      isFilterLoading: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_FILTER_PAGE") {
    return {
      ...state,
      filterCityPage: action.filterCityPage,
    };
  }
  return state;
};
